import { ProductType } from "@obg/core.config";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { DeviceExperience, DeviceType, EnvironmentType } from "@obg/ngx.global";
import { take } from "lodash-es";

import { APP_CONTEXT_ACTION_TYPE } from "./app-context.action";
import { PRODUCT_HISTORY_SIZE } from "./app-context.const";
import { AppContextState } from "./app-context.model";

const INITIAL_STATE: AppContextState = {
	productHistory: [],
	environment: EnvironmentType.Dev,
	isDebug: true,
	version: "",
	deviceType: DeviceType.Mobile,
	deviceExperience: DeviceExperience.Web,
};

export function appContextReducer(state = INITIAL_STATE, action: ActionWithPayload): AppContextState {
	switch (action.type) {
		case APP_CONTEXT_ACTION_TYPE.setProduct: {
			return {
				...state,
				product: action.payload as ProductType,
				productHistory: take([state.product, ...state.productHistory], PRODUCT_HISTORY_SIZE) as ProductType[],
			};
		}
		default:
			return state;
	}
}
